// ags-line-slider-control.ts
import { ValueList } from "appworks/utils/value-list";
import { slotModel } from "slotworks/model/slot-model";
import { AgsAbstractSliderControl } from "./ags-abstract-slider-control";

export class AgsLineSliderControl extends AgsAbstractSliderControl {
    /**
     * Sets the enabled state of the object.
     * The object's enabled state depends on the value of the 'enabled' parameter and the availability of free bets.
     *
     * @param enabled - A boolean value indicating whether the object should be enabled.
     *                  'true' to enable the object, 'false' to disable it.
     */
    public setEnabled(enabled: boolean): void {
        const { freeBet } = slotModel.read().bet;
        super.setEnabled(!freeBet && enabled);
    }

    /**
     * Overrides abstract method to format slider value as string.
     * @param index The index of the slider value.
     * @returns The formatted string value of the slider.
     */
    protected override formatFunction(index: number) {
        const value: number = this.sliderValues.values[index];
        return value.toString();
    }

    /**
     * Gets model data for slider values from credits per line model data in slotModel.
     * @returns The ValueList of slider values.
     */
    protected getModelData(): ValueList<number> {
        return slotModel.read().bet.winLines;
    }

    /**
     * Determines if zero value option should be displayed.
     * @returns A boolean indicating if zero value option should be displayed.
     */
    protected override shouldShowZeroValueOption() {
        return false;
    }

    /**
     * Saves selected slider value to credits per line model data in slotModel.
     * @param selectedValue The selected value of the slider.
     */
    protected saveModelData(selectedValue: number) {
        const { bet } = slotModel.read();
        bet.winLines.currentValue = selectedValue;
        bet.winLines.lastSelectedValue = selectedValue ?? 0;
        slotModel.write({ bet });
    }
}

